// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"AniStickyB_TheComp__GS_pV"};